import { Pipe, PipeTransform } from '@angular/core';
import { GalleryStatus } from '@nusign/picflow-backend-types';

@Pipe({
  name: 'galleryStatusName',
  standalone: true,
})
export class GalleryStatusNamePipe implements PipeTransform {
  transform(value: GalleryStatus): string {
    if (value === 'approved') return 'Approved';
    if (value === 'no_status') return 'None';
    if (value === 'progress') return 'In Progress';
    if (value === 'review') return 'Needs Review';
    if (value === 'revisions') return 'Revisions';
  }
}
